import { PaintedScene } from '../PaintedScene';

export const GROWN_OVER_OASIS_PHASER_KEY = 'GrownOverOasisScene' as const;
export const GROWN_OVER_OASIS_MANIFEST_KEY = 's-203-grown-over-oasis' as const;

export class GrownOverOasisScene extends PaintedScene {
  constructor() {
    super(GROWN_OVER_OASIS_PHASER_KEY, GROWN_OVER_OASIS_MANIFEST_KEY);
  }
}
